// removed by extract-text-webpack-plugin
module.exports = {"container":"NoSlotsFound__container___YRuR7"};